import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

export function BasicsStep({ t, set, canEdit }) {
  return (
    <section className="panel grid max-w-3xl gap-5 p-6" data-testid="builder-basics">
      <label className="space-y-1 text-sm"><span className="font-medium">Name</span>
        <Input value={t.name} disabled={!canEdit} onChange={(e) => set({ name: e.target.value })} placeholder="e.g. Customer support assessment" data-testid="basics-name" />
        <span className="text-xs text-ink-muted">Candidates see this name.</span>
      </label>
      <label className="space-y-1 text-sm"><span className="font-medium">Description</span>
        <Textarea rows={3} value={t.description} disabled={!canEdit} onChange={(e) => set({ description: e.target.value })} placeholder="What it covers and why you ask candidates to take it." data-testid="basics-description" />
      </label>
      <div className="flex flex-wrap gap-6">
        <label className="space-y-1 text-sm"><span className="font-medium">Time limit</span>
          <select value={t.time_limit_min ?? ""} disabled={!canEdit} onChange={(e) => set({ time_limit_min: e.target.value ? Number(e.target.value) : null })} className="block h-9 rounded-lg border border-line bg-white px-2" data-testid="basics-time-limit">
            <option value="">No limit (recommended)</option>
            {[15, 30, 45, 60, 90].map((m) => <option key={m} value={m}>{m} minutes</option>)}
          </select></label>
        <label className="space-y-1 text-sm"><span className="font-medium">Link expiry</span>
          <select value={t.expiry_days ?? ""} disabled={!canEdit} onChange={(e) => set({ expiry_days: e.target.value ? Number(e.target.value) : null })} className="block h-9 rounded-lg border border-line bg-white px-2" data-testid="basics-expiry">
            <option value="">Never (default)</option>
            {[3, 5, 7, 10, 14].map((d) => <option key={d} value={d}>After {d} days</option>)}
          </select></label>
      </div>
    </section>
  );
}
